// Import Dependencies
import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';

import Checkbox from '~/common/components/Checkbox';

// Import Stylesheet
import styles from './newsletterCheckbox.css';

@inject('sharedFormUtilsStore', 'formsStore')
@observer
export default class NewsletterCheckbox extends Component {
    renderTermsOfServiceLink(text) {
        return (
            <a
                className={styles.termsConditionsLink} href="https://www.goto.com/company/legal/terms-and-conditions"
                target="_blank"
            >{text}</a>
        );
    }
    renderPrivacyLink(text) {
        return (
            <a
                className={styles.termsConditionsLink} href="https://www.goto.com/company/legal/privacy"
                target="_blank"
            >{text}</a>
        );
    }
    renderOptOutButton(text) {
        const { sharedFormUtilsStore } = this.props;

        return (
            <button
                className={styles.displayEmailOptIn}
                onClick={() => sharedFormUtilsStore.setDisplayOptIn(!sharedFormUtilsStore.displayOptIn)}
            >{text}</button>
        );
    }

    render() {
        const { button, formsStore, sharedFormUtilsStore, isCheckoutABTest, modifier } = this.props;
        return (
            <div className={modifier || ''}>
                <p className={styles.termConditions}>
                    {isCheckoutABTest ?
                        <Fragment>
                            By clicking “Complete Purchase” you are agreeing to the {this.renderTermsOfServiceLink('Terms')} & {this.renderPrivacyLink('Privacy Policy')}. You also agree to receive marketing promotional emails (or you can {this.renderOptOutButton('opt-out')}.)
                        </Fragment>
                        : <Fragment>
                            By clicking "{button}" I agree to the {this.renderTermsOfServiceLink('Terms of Service')} and {this.renderPrivacyLink('Privacy Policy')}.
                            I want to receive promotional emails, including product updates, special offers and best practices, unless I {this.renderOptOutButton('opt-out')}.
                        </Fragment>
                    }
                </p>
                {sharedFormUtilsStore.displayOptIn &&
                    <div className={styles.newsletterContainer}>
                        <Checkbox
                            checked={!formsStore.IsNewsletter}
                            id="IsNewsletter"
                            label='I prefer not to receive promotional emails.'
                            modifier={styles.isNewsletterLabel}
                            name="IsNewsletter"
                            onChange={() => formsStore.toggleNewsletter()}
                        />
                    </div>
                }
            </div>
        );
    }
}
